export class Errors {
    errors : {[key : string] : string} = {};
}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/core/models/errors.module.ts